<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("stock_transfer_voucher")}}</h4>
                <p class="text-subtitle-1">{{$t("transfer_stock_items_between_warehouses")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <TransferIssueVoucherForm 
                    ref="form" 
                    v-model="data"
                    :warehouseId="data.source_warehouse_id"
                    />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn class="primary" block @click="handleSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    {{$t("save")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="handleCancel">
                    {{$t("cancel_btn")}}
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import TransferIssueVoucherForm from '../../../components/warehouse/transfer/TransferIssueVoucherForm.vue';
import PAlert from '../../../components/common/PAlert.vue';
import stockTransferAPI from './../../../services/stockJournal/stockTransfer';
import { v4 as uuid } from 'uuid';

export default {
    components: {
        TransferIssueVoucherForm,
        PAlert
    },
    data() {
        return {
            data: {},
            alert: {
                value: false,
                content: "Are you sure?",
                callback: null
            },
            loading: false,
            idempotentKey: null
        }
    },
    methods: {
        handleSave() {
            this.alert = {...this.alert, content: this.$t("are_you_sure_you_want_to_save"), value: true, callback: this.save }
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            stockTransferAPI.create({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.replace({
                    name: "TransferIssueVoucherDisplay",
                    params: {
                        id: response.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, content: this.$t("are_you_sure_cancel"), value: true, callback: this.cancel }
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.data.source_warehouse_id = Number(this.$route.params.warehouseId);
        this.idempotentKey = uuid();
    }
}
</script>